import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import config from '../../config';

class Page extends Component {
  getMetaTags(
    {
      title,
      description,
      image,
      noCrawl,
    }
  ) {
    const metaTags = [
      { itemprop: 'name', content: title },
      { itemprop: 'description', content: description },
      { itemprop: 'image', content: image },
      { name: 'description', content: description },
      { name: 'twitter:image:src', content: image },
      { property: 'og:title', content: title },
      // { property: 'og:url', content: `${SITE_URL}${pathname}`, },
      { property: 'og:image', content: image },
      { property: 'og:description', content: description },
      // { property: 'og:site_name', content: SITE_URL, },
      { property: 'og:type', content: 'WebApp' },
      //   { property: 'fb:app_id', content: FACEBOOK_APP_ID }

      //twitter tags
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ];

    if (noCrawl) metaTags.push({ name: 'robots', content: 'noindex, nofollow' });

    return metaTags;
  }

  getCanonicalUrl = canonicalUrl =>
    canonicalUrl ? [{ rel: 'canonical', href: canonicalUrl }] : [];

  render() {
    const { children, id, className, canonicalUrl, location, ...rest } = this.props;

    return (
      <div id={id} className={className}>
        <Helmet
          htmlAttributes={{
            lang: 'en',
            itemscope: undefined,
            itemtype: `http://schema.org/${rest.schema || 'WebPage'}`,
          }}
          link={this.getCanonicalUrl(canonicalUrl)}
          title={rest.title}
          meta={this.getMetaTags(rest, location.pathname)}
        />
        {children}
      </div>
    );
  }
}

Page.defaultProps = {
  image: config.honeyguideDefaultImage,
};

export default withRouter(Page);




// WEBPACK FOOTER //
// ./src/components/Page/Page.jsx